import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import { SAVE_200_MSG } from 'constants/index'
import { getWorkOrdersForInvoice2Item } from 'services/workOrder'
import {
  deleteWorkOrdersFromInvoiceItem,
  addWorkOrdersToInvoiceItem,
} from 'services/invoice2ItemWorkOrder'
import actions from './actions'

function* fetchExistingWorkOrderFilterForInvoice2Item({
  size,
  index,
  searchTerm,
  orderBy,
  invoice2ItemID,
}) {
  size = size || localStorage.getItem('pageSize') || 150

  const savedFilters = localStorage.getItem('invoiceItemExistingWorkOrderFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)
    invoice2ItemID = invoice2ItemID || parsedFilters.invoice2ItemID || null
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    getWorkOrdersForInvoice2Item,
    size,
    index,
    searchTerm,
    orderBy,
    null,
    null,
    null,
    null,
    null,
    invoice2ItemID,
  )
  yield put({
    type: actions.LIST_WORKORDER_FOR_EXISTING_INVOICE2_ITEM,
    result,
  })
}

function* fetchDeleteWorkOrdersFromInvoiceItem(values) {
  console.log('fetchDeleteWorkOrdersFromInvoice', values)
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(deleteWorkOrdersFromInvoiceItem, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
      yield put({
        type: actions.DELETE_WORKORDERS_FROM_INVOICE2_ITEM_RECIEVED,
        result,
      })
    } else {
      notification.error({ message: 'Error', description: result.message })
      yield put({
        type: actions.RESPONSE_ERROR,
        message: result.message,
      })
    }
  }
}

function* fetchAddWorkOrdersToInvoiceItem(values) {
  console.log('fetchAddWorkOrdersToInvoiceItem', values)
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(addWorkOrdersToInvoiceItem, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: SAVE_200_MSG, description: result.message })
      yield put({
        type: actions.ADD_WORKORDERS_TO_INVOICE2_ITEM_RECIEVED,
        result,
      })
    } else {
      notification.error({ message: 'Error', description: result.message })
      yield put({
        type: actions.RESPONSE_ERROR,
        message: result.message,
      })
    }
  }
}
export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.FETCH_WORKORDERS_FILTER_FOR_EXISTING_INVOICE2_ITEM,
      fetchExistingWorkOrderFilterForInvoice2Item,
    ),
    takeEvery(actions.DELETE_WORKORDERS_FROM_INVOICE2_ITEM, fetchDeleteWorkOrdersFromInvoiceItem),
    takeEvery(actions.ADD_WORKORDERS_TO_INVOICE2_ITEM, fetchAddWorkOrdersToInvoiceItem),
  ])
}
